import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getChatSummaryList } from "../../Redux/Slice/Chats/ChatSummaryListSlice";
import CalendarIcon from "../../Assets/svgs/CalendarIcon";
import { AssistantIcon } from "../../Assets/svgs/AssistantIcon";
import ImageIcon from "../../Assets/images/VoxApp-Icon.png";
import { Loader } from "../../Common/Loader";
import { ChatSummaryPopup } from "./ChatSummaryPopup";

const ChatSummaryList = ({
  contactId,
  assistantId,
  summaryFormPopup,
  onClearSummaryDetailFilter,
  isCallExternal,
  isExternalFromEmail,
  isWidgetCall,
  domainName,
  assistantName,
}) => {
  const dispatch = useDispatch();
  const [summaryPage, setSummaryPage] = useState(1);
  const [totalSummaryPages, setTotalSummaryPages] = useState(1);
  const [summaryData, setSummaryData] = useState([]);
  const INITIAL_SUMMARY_POPUP = {
    visible: false,
    data: null,
  };
  const [summaryPopup, setSummaryPop] = useState(INITIAL_SUMMARY_POPUP);
  const [isLoading, setIsLoading] = useState(false);

  const summaryCounts = useMemo(() => {
    let count = 0;
    summaryData?.forEach((summary) => {
      count += Array.isArray(summary?.summaries)
        ? summary?.summaries?.length
        : 0;
    });
    return count;
  }, [summaryData]);

  const onGetChatSummary = async (page) => {
    if (isLoading) {
      setIsLoading(true);
    }
    try {
      const result = await dispatch(
        getChatSummaryList({
          page: page,
          contactId: contactId,
          assistantId: assistantId,
          from: summaryFormPopup?.data?.fromDate,
          to: summaryFormPopup?.data?.toDate,
          time: summaryFormPopup?.data?.time,
          isCallExternal: isCallExternal,
          isExternalFromEmail: isExternalFromEmail,
          widgetChatId: isWidgetCall ? contactId : null,
        })
      );
      if (
        getChatSummaryList.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        if (Array.isArray(result?.payload?.data)) {
          if (page == 1) {
            setSummaryData(result?.payload?.data);
          } else {
            setSummaryData((prev) => [...result?.payload?.data, ...prev]);
          }
        }
        setSummaryPage((prev) => prev + 1);
        setTotalSummaryPages(result?.payload?.pagination?.totalPages);
      }
    } catch (error) {
    } finally {
      if (isLoading) {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    onGetChatSummary(1);
  }, [summaryFormPopup?.data]);

  return (
    <div className="chatsWrap__body">
      {isLoading ? <Loader /> : ""}
      {summaryPopup.visible ? (
        <ChatSummaryPopup
          summary={summaryPopup.data}
          onClose={() => setSummaryPop(INITIAL_SUMMARY_POPUP)}
          onClickOriginalMsg={onClearSummaryDetailFilter}
        />
      ) : null}
      <div className="chatsSearchResult">
        <div className="chatsWrap__body__head">
          <h3 className="title">
            All Chat Results{" "}
            <span className="count count--danger">{summaryCounts}</span>
            <span className="btn" onClick={onClearSummaryDetailFilter}>
              Remove Filter
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 3.11125L7.11125 0L8 0.888749L4.88875 4L8 7.11125L7.11125 8L4 4.88875L0.888749 8L0 7.11125L3.11125 4L0 0.888749L0.888749 0L4 3.11125Z"
                  fill="#4F4F4F"
                />
              </svg>
            </span>
          </h3>
          <p className="para">
            Showing Results From :
            <span>
              <CalendarIcon />
              {summaryFormPopup?.data?.fromDate}
            </span>
            <span>{" - "}</span>
            <span>
              <CalendarIcon />
              {summaryFormPopup?.data?.toDate}
            </span>
          </p>
        </div>
        {summaryData && Array.isArray(summaryData) && summaryData?.length ? (
          summaryData?.map((summaryListItem) => (
            <React.Fragment>
              <p className="textDay">
                <span>{summaryListItem?.date}</span>
              </p>
              <ul className="listCol__list listing__list">
                {Array.isArray(summaryListItem?.summaries)
                  ? summaryListItem?.summaries?.map((summary) => (
                      <li className="listCol__list__item">
                        <div className="chatCard">
                          <div className="chatCard__initials">
                            <img
                              src={summary?.contact?.avatar ?? ImageIcon}
                              alt=""
                            />
                          </div>
                          <div className="chatCard__info">
                            <div className="chatCard__info__col">
                              <h4 className="name">
                                {isWidgetCall
                                  ? domainName
                                  : summary?.contact?.contactName}
                              </h4>
                              <p>{summary?.summary}</p>
                            </div>
                          </div>
                        </div>
                        <div className="chatCard__actions">
                          <p className="para">
                            <AssistantIcon />
                            {assistantName ?? summary?.assistant?.name}
                            <span className="textGray">{summary?.time}</span>
                          </p>
                          <button
                            className="link link__primary"
                            onClick={() =>
                              setSummaryPop({
                                visible: true,
                                data: summary?.summary,
                              })
                            }
                          >
                            View Chat Summary
                          </button>
                        </div>
                      </li>
                    ))
                  : null}
              </ul>
            </React.Fragment>
          ))
        ) : (
          <React.Fragment>
            <p className="textDay"></p>
            <ul className="listCol__list listing__list">
              <div className="no-data">No Summary Found!</div>
            </ul>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default ChatSummaryList;
